/** Absolute date+time in the viewer's locale (e.g. "Jun 11, 2026, 2:00 PM"). */
export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}

const RELATIVE_DIVISIONS: { amount: number; unit: Intl.RelativeTimeFormatUnit }[] = [
  { amount: 60, unit: "seconds" },
  { amount: 60, unit: "minutes" },
  { amount: 24, unit: "hours" },
  { amount: 7, unit: "days" },
  { amount: 4.34524, unit: "weeks" },
  { amount: 12, unit: "months" },
  { amount: Number.POSITIVE_INFINITY, unit: "years" },
];

/**
 * Human-friendly relative time ("in 3 days", "tomorrow", "in 5 hours",
 * "3 days ago") so customers don't have to compute dates themselves. Picks the
 * coarsest sensible unit and defers to Intl for locale + wording (numeric:auto
 * yields "today"/"tomorrow"/"yesterday"). Returns "" for an unparseable input.
 */
export function formatRelativeTime(
  iso: string,
  now: number = Date.now(),
  locale?: string | string[],
): string {
  const target = new Date(iso).getTime();
  if (Number.isNaN(target)) {
    return "";
  }
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
  let duration = (target - now) / 1000;
  for (const division of RELATIVE_DIVISIONS) {
    if (Math.abs(duration) < division.amount) {
      return rtf.format(Math.round(duration), division.unit);
    }
    duration /= division.amount;
  }
  return "";
}
